import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EntityTypeCellRendererComponent } from './entity-type-cell-renderer.component';

@NgModule({
  imports: [CommonModule, MatTooltipModule],
  declarations: [EntityTypeCellRendererComponent],
  exports: [EntityTypeCellRendererComponent],
})
export class EntityTypeCellRendererModule {}
